module.exports = "/assets/data/9afea8f6ccfe818daf62085feef7a1bb-DN7.data.json";